import { FunctionComponent, useState, useCallback } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

interface CopyToVariantDialogProps {
    open: boolean;
    title: string;
    onClose: () => void;
    onConfirm: (targetProductId: string, targetVariantId: string) => void;
    isLoading: boolean;
}

export const CopyToVariantDialog: FunctionComponent<CopyToVariantDialogProps> = ({
    open,
    title,
    onClose,
    onConfirm,
    isLoading,
}) => {
    const [targetProductId, setTargetProductId] = useState("");
    const [targetVariantId, setTargetVariantId] = useState("");

    const handleConfirm = useCallback(() => {
        if (!targetProductId.trim() || !targetVariantId.trim()) return;
        onConfirm(targetProductId.trim(), targetVariantId.trim());
    }, [targetProductId, targetVariantId, onConfirm]);

    const handleClose = useCallback(() => {
        setTargetProductId("");
        setTargetVariantId("");
        onClose();
    }, [onClose]);

    const isValid = targetProductId.trim().length > 0 && targetVariantId.trim().length > 0;

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                    Enter the target product ID and variant ID to copy to.
                </Typography>
                <TextField
                    label="Target Product ID"
                    fullWidth
                    size="small"
                    value={targetProductId}
                    onChange={(e) => setTargetProductId(e.target.value)}
                    style={{ marginBottom: 16 }}
                    placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                />
                <TextField
                    label="Target Variant ID"
                    fullWidth
                    size="small"
                    value={targetVariantId}
                    onChange={(e) => setTargetVariantId(e.target.value)}
                    placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={isLoading}>
                    Cancel
                </Button>
                <LoadingButton
                    variant="contained"
                    onClick={handleConfirm}
                    loading={isLoading}
                    disabled={!isValid}>
                    Copy
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};
